module.exports = __webpack_public_path__ + "static/media/logo_BIDV.961834f9.png";